export const dashboardTourSteps = [
  {
    target: '.dashboard-stats',
    content: 'Dashboard üzerinde kampanya, kişi ve rapor istatistiklerinizi görebilirsiniz.',
    placement: 'bottom',
    title: 'Dashboard İstatistikleri',
  },
  {
    target: '.quick-actions',
    content: 'Hızlı işlemler menüsü ile yeni kampanya oluşturabilir, kişi ekleyebilirsiniz.',
    placement: 'bottom',
    title: 'Hızlı İşlemler',
  },
  {
    target: '.recent-campaigns',
    content: 'Son kampanyalarınızı buradan takip edebilirsiniz.',
    placement: 'top',
    title: 'Son Kampanyalar',
  },
  {
    target: '.sidebar-nav',
    content: 'Sol menüden farklı sayfalara geçiş yapabilirsiniz: Kampanyalar, Kişiler, Şablonlar, Raporlar ve daha fazlası.',
    placement: 'right',
    title: 'Navigasyon Menüsü',
  },
];

export const campaignsTourSteps = [
  {
    target: '.campaigns-header',
    content: 'Kampanyalar sayfasında tüm e-posta kampanyalarınızı yönetebilirsiniz.',
    placement: 'bottom',
    title: 'Kampanya Yönetimi',
  },
  {
    target: '.create-campaign-btn',
    content: 'Yeni bir kampanya oluşturmak için bu butona tıklayın.',
    placement: 'bottom',
    title: 'Yeni Kampanya',
  },
  {
    target: '.campaigns-table',
    content: 'Tüm kampanyalarınızı bu tabloda görebilir, durumlarını takip edebilirsiniz.',
    placement: 'top',
    title: 'Kampanya Listesi',
  },
  {
    target: '.campaign-filters',
    content: 'Kampanyaları durumuna, tarihe veya arama yaparak filtreleyebilirsiniz.',
    placement: 'bottom',
    title: 'Filtreleme',
  },
];

export const templatesTourSteps = [
  {
    target: '.templates-header',
    content: 'Şablonlar sayfasında e-posta şablonlarınızı oluşturabilir ve yönetebilirsiniz.',
    placement: 'bottom',
    title: 'Şablon Yönetimi',
  },
  {
    target: '.create-template-btn',
    content: 'Yeni bir e-posta şablonu oluşturmak için bu butona tıklayın.',
    placement: 'bottom',
    title: 'Yeni Şablon',
  },
  {
    target: '.templates-table',
    content: 'Tüm şablonlarınızı burada görebilir, düzenleyebilir veya silebilirsiniz.',
    placement: 'top',
    title: 'Şablon Listesi',
  },
  {
    target: '.template-editor',
    content: 'Zengin metin editörü ile profesyonel e-posta şablonları hazırlayın.',
    placement: 'left',
    title: 'Şablon Editörü',
  },
];

export const contactsTourSteps = [
  {
    target: '.contacts-header',
    content: 'Kişiler sayfasında tüm kişilerinizi ve iletişim bilgilerini yönetebilirsiniz.',
    placement: 'bottom',
    title: 'Kişi Yönetimi',
  },
  {
    target: '.add-contact-btn',
    content: 'Yeni kişi eklemek için bu butona tıklayın.',
    placement: 'bottom',
    title: 'Yeni Kişi',
  },
  {
    target: '.contacts-table',
    content: 'Tüm kişilerinizi bu tabloda görebilir, gruplara ayırabilirsiniz.',
    placement: 'top',
    title: 'Kişi Listesi',
  },
  {
    target: '.contact-groups',
    content: 'Kişileri gruplandırarak hedeflenmiş kampanyalar oluşturabilirsiniz.',
    placement: 'left',
    title: 'Kişi Grupları',
  },
];
